import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import FormContainer from '../../components/formContainer/formContainer'
import { TextInput,  ImageUploadInput, SingleCheckBoxInput } from '../../components/input/inputModule'
import { getDuzenleData } from '../helpers/componentApiHelpers/getDuzenleData'
import { sendDataUpload, changeDataUpload } from '../helpers/componentApiHelpers/sendData'
import { getIdFromUrl } from '../helpers/getIdFromUrl'
import { getCall } from '../helpers/componentApiHelpers/getCall'

class SonucAgacEnter extends Component {

    constructor(props) {
        super(props)
        this.state = {
            name: "",
            nameEn: "",
            nameLtn: "",
            family: "",
            familyEn: "",
            familyLtn: "",
            image: "",
            mainType: "",
            shape: "",
            agacCali: "",
            yaprakTip: "",
            dependencies: {agacCali: [], yaprakTip: [], bitkiCesitleri: [], yaprakSekli: []},
            dataCame: false
        }
        this.onValChange = this.onValChange.bind(this)
    }

    async componentDidMount() {
        const getDependencies = await getCall("/resultTree/getDependencies")
        await getDependencies.data.agacCali.map(d => {
            d.labelStrong = d.typeName
        })
        await getDependencies.data.yaprakTip.map(d => {
            d.labelStrong = d.typeName
        })
        await getDependencies.data.bitkiCesitleri.map(d => {
            d.labelStrong = d.typeName
        })
        await getDependencies.data.yaprakSekli.map(d => {
            d.labelStrong = d.typeName
        })

        this.setState({dependencies: getDependencies.data})
        await getDuzenleData(2, "resultTree", this)
    }

    async onValChange(e, stateProp) {
        e.preventDefault()
        await this.setState({ [stateProp]: e.target.value })
    }

    async send() {
        if (this.state.id === "" || this.state.id === undefined) {
            await sendDataUpload("/resultTree", "/sonucAgac", this)
        } else {
            await changeDataUpload("/resultTree/", "/sonucAgac", this)
        }
    }

    render() {
        return (
            <React.Fragment>
                <HeaderLine header="Ekle" />
                <FormContainer
                    sending={this.state.sending}
                    dataCame={getIdFromUrl(this.props.history.location.pathname, 2) !== undefined && !this.state.dataCame}
                >
                    <p className="main-paragraph">Sonuç Ağaç</p>
                    <TextInput ref="name" label="Bitki İsmi" value={this.state.name} stateProp="name" onChange={this.onValChange} />
                    <TextInput ref="nameEn" label="Bitki İsmi En" value={this.state.nameEn} stateProp="nameEn" onChange={this.onValChange} notRequired/>
                    <TextInput ref="nameLtn" label="Bitki İsmi Ltn" value={this.state.nameLtn} stateProp="nameLtn" onChange={this.onValChange} notRequired/>
                    <TextInput ref="family" label="Bitki Ailesi" value={this.state.family} stateProp="family" onChange={this.onValChange} />
                    <TextInput ref="familyEn" label="Bitki Ailesi En" value={this.state.familyEn} stateProp="familyEn" onChange={this.onValChange} notRequired/>
                    <TextInput ref="familyLtn" label="Bitki Ailesi Ltn" value={this.state.familyLtn} stateProp="familyLtn" onChange={this.onValChange} notRequired/>
                    <SingleCheckBoxInput baslik="Ana Kategori" data={this.state.dependencies.bitkiCesitleri} value={this.state.mainType} stateProp="mainType" onChange={this.onValChange} /><br></br>
                    <SingleCheckBoxInput baslik="Ağaç Çalı" data={this.state.dependencies.agacCali} value={this.state.agacCali} stateProp="agacCali" onChange={this.onValChange} /><br></br>
                    <SingleCheckBoxInput baslik="Yaprak Tipi" data={this.state.dependencies.yaprakTip} value={this.state.yaprakTip} stateProp="yaprakTip" onChange={this.onValChange} /><br></br>
                    <SingleCheckBoxInput baslik="Yaprak Şekli" data={this.state.dependencies.yaprakSekli} value={this.state.shape} stateProp="shape" onChange={this.onValChange} /><br></br>
                    <ImageUploadInput id="image" stateProp="image" value={this.state.image} onChange={this.onValChange} />
                    {this.state.errorMessage && <p style={{ color: "red" }}>{this.state.errorMessage}</p>}
                    <button onClick={() => this.send()} className="save-button">Ekle</button>
                </FormContainer>
            </React.Fragment>
        )
    }
}

export default SonucAgacEnter